import { createContext } from 'react';
import { PermitErrorModal } from '../search';

interface RelaseIdCardContextType {
  permitError: PermitErrorModal;
  setPermitError: (value: PermitErrorModal) => void;
}

const defaultValues = {
  permitError: {
    open: false,
    message: '',
  },
  setPermitError: () => {
    return;
  },
};
const ReleaseIdCardContext = createContext<RelaseIdCardContextType>(defaultValues);

export default ReleaseIdCardContext;
